import DarkLayout from '@components/shared/DarkLayout';
import NewSectionTitle from '@components/shared/NewSectionTitle';
import { scrollToElement } from '@utils/functions/throttle';
import React from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { FiArrowUpRight } from 'react-icons/fi';
import { Primary } from 'stories/Button.stories';

const whyAlmaBetterPoints = [
  {
    title: 'Zero Cost Hirings',
    description: 'We nurture long-term relationships with recruiters through zero fees.',
  },
  {
    title: 'TAT (< 2 weeks)',
    description: 'We swiftly fill job vacancies, facilitating immediate joining.',
  },
  {
    title: 'Pre-assessed, Elite Talent',
    description: `We evaluate employability, ensuring access to top-tier talented candidates.`,
  },
  {
    title: 'Mentor-Endorsed Profiles',
    description:
      'We have rigorous screening process to ensure quality matches vetted by top experts.',
  },
  {
    title: 'Year-Round Recruitment',
    description: `We consistently deliver skilled professionals, and hiring happens all-year.`,
  },
];

function WhyAlmaBetter() {
  return (
    <DarkLayout
      customStyle="gap-y-[64px] py-[60px] md:py-[120px] px-[16px] md:px-[124px] place-items-center"
      gridMode
    >
      <NewSectionTitle headingStyle={'text-white'} text={'Why'} highlightedText={'AlmaBetter?'} />

      <div className="relative z-10 flex flex-wrap justify-center gap-[48px]">
        {whyAlmaBetterPoints.map((points, index) => (
          <PointCard {...points} key={index} />
        ))}
      </div>

      <Primary
        label={'Start Hiring'}
        size={'large'}
        customStyle="flex items-center gap-x-[8px] mt-8 relative z-10"
        onClick={() => scrollToElement('hireForm')}
      >
        <FaArrowRight size={20} className="mt-1" />
      </Primary>
    </DarkLayout>
  );
}

export default WhyAlmaBetter;

const PointCard = ({ title, description }) => {
  return (
    <div
      className={`bytes-card-bg group flex cursor-pointer flex-col gap-y-6 overflow-hidden rounded-xl p-6 font-satoshi-medium transition-all duration-75 ease-in-out hover:scale-125	md:w-[350px]`}
    >
      <h5 className="whitespace-break-spaces flex items-center justify-between font-satoshi-bold text-[20px] leading-7 text-white group-hover:text-red">
        {title}
      </h5>

      <p className="font-satoshi-regular text-[14px] leading-5 tracking-normal text-white">
        {description}
      </p>
    </div>
  );
};
